export const commonNavButtonStyles = {
  textTransform: 'uppercase' as const,
  color: '#e9ecef',
  '&:hover': {
    background: '#0a1d46',
    color: 'white',
    '& .MuiListItemIcon-root': {
      color: 'white',
    },
  },
  '&:focus': {
    background: '#0a1d46',
    color: 'white',
    '& .MuiListItemIcon-root': {
      color: 'white',
    },
  },
  '&.active': {
    background: '#383f73 !important',
    color: 'white',
    '& .MuiListItemIcon-root': {
      fontSize: '1.2em',
      color: 'white',
    },
  },
};
